import { useEffect, useRef, useState } from "react";
import "./CellEditor.css";

export const CellEditor = (props: { value: number; onValueUpdate: (newValue: number) => void; }) => {
    const [value, setValue] = useState<{ i_val: number; n_val: number; }>({ i_val: props.value, n_val: props.value, });
    const [editing, setEditing] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
            // inputRef.current?.select();
        }
    }, [editing]);

    const onSpanClick = () => { setEditing(true); };

    const onFocusOut = () => {
        setEditing(false);

        if (value.i_val !== value.n_val) {
            const newValue = value.n_val;
            props.onValueUpdate(newValue);
            setValue({ i_val: newValue, n_val: newValue, });
        }
    };

    return editing ? (
        <input className="cell_input"
            ref={inputRef}
            value={value.n_val}
            inputMode="numeric"
            onBlur={onFocusOut}
            onChange={(e) => setValue(prev => ({ ...prev, n_val: Number(e.target.value), }))}
        />
    ) : (
        <span className="cell_span" onClick={onSpanClick}>
            {value.n_val}
        </span>
    );
};